
import {useStore} from "@/store";
import {useRouter, useRoute} from "vue-router";
import {defineComponent, reactive, ComputedRef, computed, toRefs, watch} from "vue";
import  reportMsgUt from "@/util/reportMsg";

interface State {
    tocOnlyShowFlaw: any;
    checkItemList: any;
    normalList: any;
    unusualList: any;
    defaultList: any;
    onlyFlawList: any;
    unusualObj: any;
    normalObj: any;
    photoList: any;
    accidentFlag: any;
    isFire: any;
    isWater: any;
    reportMsg: object;

}
export default defineComponent({
    name: 'checkContent1226',
    props: {
        carContentRenderData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        carContentParentIndex: {
            type: Number,
            default: -1
        },
        carContentParentCode: {
            type: String,
            default: ''
        },
    },
    setup(props) {
        let state: State = reactive({
            tocOnlyShowFlaw: false,
            checkItemList: [],
            normalList: [],
            unusualList: [],
            defaultList: [],
            onlyFlawList: [],
            unusualObj: {},
            normalObj: {},
            photoList: [],
            accidentFlag: -1,
            isFire: -1,
            isWater: -1,
            reportMsg: {},
        })
        state.reportMsg = reportMsgUt;
        const router = useRouter();
        let store = useStore();
        let tocOnlyShowFlawS: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
        const {carContentRenderData} = toRefs(props);
        const checkItemList  = carContentRenderData.value.checkItemList;
        checkItemList.forEach(item => {
            if (item.unusual) {
                state.unusualList.push(item);
            } else {
                state.normalList.push(item);
            }
        })
        let {defectCount,limitedCount,normalCount,noSuchCount } = carContentRenderData.value;
        state.normalObj = {
            title: '正常项',
            code: 'normal',
            hide: false,
            defectCount,
            limitedCount,
            normalCount,
            noSuchCount,
            itemLists: state.normalList,
            photoList: carContentRenderData.value.normalPhotoList
        };
        state.unusualObj = {
            title: '异常项',
            code: 'unusual',
            hide: false,
            defectCount,
            limitedCount,
            normalCount,
            noSuchCount,
            itemLists: state.unusualList,
            photoList: carContentRenderData.value.defectPhotoList
        };
        if (defectCount > 0) {
            state.defaultList = [state.unusualObj, state.normalObj];
        } else {
            state.defaultList = [state.normalObj];
        }
        state.onlyFlawList = [state.unusualObj]
        state.checkItemList = state.defaultList;
        watch(tocOnlyShowFlawS, (data: any) => {
            state.tocOnlyShowFlaw = data;
            if (data) {
                state.checkItemList = state.onlyFlawList;
            } else {
                state.checkItemList = state.defaultList;
            }
        }, {immediate: true})
        
        let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
        
        watch(dataInfo, (data: any) => {
            const {defectPhotoList, accidentFlag, isFire, isWater} = data
            state.photoList = defectPhotoList;
            state.accidentFlag = accidentFlag;
            state.isFire = isFire;
            state.isWater = isWater;
        },{immediate: true})
        
        return {
            state,
            router,
            store,
        }
    },
    methods: {
        getCongValueDes(congValue: string,redSign: number,parentCode: string) {
            if (this.state.reportMsg['RpCK']()) {//车况报告及其车况报告加购系列走原来的严重一般逻辑
                return congValue;
            } else {
                if (parentCode === 'Accident' || parentCode === 'Fire'|| parentCode === 'SoakWater') {//事故、火烧、泡水模块
                    if (redSign === undefined) {//上线以前静态化的数据
                        return congValue;
                    } else {//有缺陷标识
                        if ((parentCode === 'Accident'&& this.state.accidentFlag > 0 ) || (parentCode === 'Fire'&& this.state.isFire  === 1) || (parentCode === 'SoakWater'&& this.state.isWater  === 1)) {
                            if (redSign === 2) {
                                if (parentCode === 'Accident') {
                                    return congValue + '(事故项)';
                                } else if (parentCode === 'Fire') {
                                        return congValue + '(火烧项)';
                                } else if (parentCode === 'SoakWater') {
                                        return congValue + '(泡水项)';
                                } else {
                                        return congValue;
                                }
                            } else {
                                return congValue;
                            }
                        } else {
                            return congValue;
                        }               
                    }
                } else {
                    return congValue;
                }
            }
        },
        getCongValueLevelStyle(level: string) {
            let valueClass = {};
            if (level === 'L002') {//严重
                valueClass = {"congValue_orangeColor": true};
            }else if (level === 'L001') {//一般
                valueClass = {"congValue_grayColor": true};
            } else {
                valueClass = {"congValue_orangeColor": true};
            }
            return valueClass;
        },
        getCongValueClass(level: string,redSign: number,parentCode: string) {
            if (this.state.reportMsg['RpCK']()) {//车况报告及其车况报告加购系列走原来的严重一般逻辑
                let valueClass = this.getCongValueLevelStyle(level);
                return valueClass;
            } else {
                if (parentCode === 'Accident' || parentCode === 'Fire'|| parentCode === 'SoakWater') {//事故、火烧、泡水模块
                    if (redSign === undefined) {
                        let valueClass = this.getCongValueLevelStyle(level);
                        return valueClass;
                    } else {
                        if ((parentCode === 'Accident'&& this.state.accidentFlag  === 2) || (parentCode === 'Fire'&& this.state.isFire  === 1) || (parentCode === 'SoakWater'&& this.state.isWater  === 1)) {
                            let valueClass = {};
                            if (redSign === 2) {
                                valueClass = {"congValue_orangeColor": true};
                                return valueClass;
                            } else {
                                valueClass = {"congValue_grayColor": true};
                                return valueClass;
                            }
                        } else {
                            let valueClass = this.getCongValueLevelStyle(level);
                            return valueClass;
                        }
                    }
                } else {
                    let valueClass = this.getCongValueLevelStyle(level);
                    return valueClass;
                }
            }
        },
        changeItemCheckType(item) {
            item.hidden = !item.hidden;
        },
        getNormalTitles(item) {
            let titles: any = [];
            let nomalObj = {
                name: '正常项',
                icon: 'fullreport-green',
                count: item.normalCount || 0
            };
            titles.push(nomalObj);
            if (item.noSuchCount > 0) {
                let positionObj = {
                    name: '无此部件',
                    icon: 'fullreport-nopart',
                    count: item.noSuchCount
                };
                titles.push(positionObj);
            }
            if (item.limitedCount > 0) {
                let constrainedObj = {
                    name: '受限不可检',
                    icon: 'fullreport-limited',
                    count: item.limitedCount
                };
                titles.push(constrainedObj);
            }
            return titles;
        },
        goToImgView(item, parentIndex, sonIndex) {
            // console.log('goToImgView'+JSON.stringify(item) + 'parentIndex' + parentIndex + 'sonIndex' + sonIndex);
            if (item.itemDesc === '无此部件') {
                return;
            }
            // let photo = item.photoList && item.photoList[0];
            // let currentIndex = 0;
            // for (let i =0;i<this.state.photoList.length;i++){
            //     let item: any = this.state.photoList[i];
            //     if (item.photoIdStr === photo.photoIdStr) {
            //         currentIndex = i;
            //         break;
            //     }
            // }
            // this.store.dispatch('savePageScrollTop', window.scrollY);
            // this.router.push({
            //     path:'/promiseFramePhotoList',
            //     query: {
            //         photoIndex: currentIndex,
            //         group: 'defect' ,
            //     }
            // })
            let photo = item.photoList && item.photoList[0];
            let queryPar: any = {
                group: 'defect',
            }
            if (item.itemDesc === '受限不可检') {
                queryPar.noImg = 1;
            } else {
                queryPar.photoCode = (photo && photo.photoIdStr) || '';
            }
            this.store.dispatch('savePageScrollTop', window.scrollY);
            this.router.push({
                path:'/tocV4PhotoList',
                query: queryPar
            })
            
        },
    }
})
